import { SeamlessApiClient } from "@mondaydotcomorg/api";

const mondayApi = new SeamlessApiClient();
const unwrapResponse = (response) =>
  response?.data?.data ?? response?.data ?? response;

const executeGraphQl = async (query) => {
  try {
    const response = await mondayApi.request(query);
    const data = unwrapResponse(response);
    if (!data) {
      throw new Error("The monday.com API returned no data.");
    }

    return data;
  } catch (error) {
    console.error("monday.com API request failed.", error);
    throw error;
  }
};

export const getWorkspaceBoards = async (workspaceId) => {
  const finalWorkspaceId = workspaceId === -1 ? "null" : workspaceId;
  if (!finalWorkspaceId) return;
  const response = await executeGraphQl(`
    query {
      boards(workspace_ids: [${finalWorkspaceId}], order_by: used_at, limit:1000) {
        id
        name
        type
        description
        updated_at
      }
    }
  `);

  return response.boards;
};

export const getBoardGroups = async (boardId) => {
  const response = await executeGraphQl(`
    query {
      boards(ids: [${boardId}]) {
        id
        name
        type
        workspace_id
        url
        board_kind
        groups {
          title
          id
        }
      }
    }
  `);

  return response.boards[0];
};

export const getUsers = async (userIds) => {
  const response = await executeGraphQl(`
    query {
      users (ids: ${JSON.stringify(userIds)}, limit: 50) {
        id
        name
        photo_tiny
      }
    }
  `);

  return response.users;
};

export const getItem = async (itemId) => {
  const response = await executeGraphQl(`
    query {
      items (ids: [${itemId}]) {
        id
        name
      }
    }
  `);

  return response.items[0];
};

export const getDocs = async (workspaceId) => {
  const finalWorkspaceId = workspaceId === -1 ? "null" : workspaceId;
  if (!finalWorkspaceId) return;
  const response = await executeGraphQl(`
      query {
        docs(workspace_ids: [${finalWorkspaceId}], limit:1000){
          name
          id
        }
      }
      `);

  return response.docs;
};

export const getAllWorkspaces = async () => {
  const response = await executeGraphQl(`
    query {
      workspaces {
        id
        name
        kind
        description
      }
    }
  `);

  return response.workspaces;
};

export const searchWorkspacesByName = async (searchString) => {  
  let matchedObjects = [];
  let currentPage = 1;
  const limit = 200;
  let hasMore = true;

  while (hasMore && matchedObjects.length < 20) {
    const response = await executeGraphQl(`
      query {
        workspaces(page: ${currentPage}, limit: ${limit}) {
          id
          name
          kind
          description
        }
      }
    `);

    const workspaces = response.workspaces || [];

    // If no workspaces came back, we're at the end
    if (workspaces.length === 0) {
      hasMore = false;
    } else {
      // Filter workspaces by search string
      const filtered = workspaces.filter(workspace => {
          return workspace.name.toLowerCase().includes(searchString.toLowerCase());
      });

      matchedObjects = matchedObjects.concat(filtered);
      currentPage++;
    }
  }

  // In case we found more than 20 in the last batch
  return matchedObjects.slice(0, 20);
}

export const searchBoardsByName = async (workspaceId, boardType, searchString) => {  
  const finalWorkspaceId = workspaceId === -1 ? "null" : workspaceId;
  if (!finalWorkspaceId) return;

  let matchedBoards = [];
  let currentPage = 1;
  const limit = 200;
  let hasMore = true;

  while (hasMore && matchedBoards.length < 20) {
    const response = await executeGraphQl(`
      query {
        boards(workspace_ids: [${finalWorkspaceId}], order_by: used_at, page: ${currentPage}, limit: ${limit}) {
          id
          name
          type
          description
          board_kind
          updated_at
        }
      }
    `);

    const boards = response.boards || [];

    // If no boards came back, we're at the end
    if (boards.length === 0) {
      hasMore = false;
    } else {
      // Filter boards by search string
      const filtered = boards.filter(board => {
        if(board.type === boardType) {
          return board.name.toLowerCase().includes(searchString.toLowerCase());
        }

        return false;
      });

      matchedBoards = matchedBoards.concat(filtered);
      currentPage++;
    }
  }

  // In case we found more than 20 in the last batch
  return matchedBoards.slice(0, 20);
}